import React, { useState, useContext } from 'react'
import PropTypes from 'prop-types'

import loadable from '@loadable/component'

const MobileMenu = loadable(() =>
  import(/* webpackChunkName: "MobileMenu" */ '../components/MobileMenu')
)

const LoginOverlay = loadable(() => import('../components/Login/LoginOverlay'))

const context = React.createContext()

export function MobileMenuProvider({ children }) {
  const [showMenu, setShowMenu] = useState(false)
  const [showLoginOverlay, setShowLoginOverlay] = useState(false)

  const open = () => {
    setShowMenu(true)
  }

  const close = () => {
    setShowMenu(false)
  }

  return (
    <context.Provider
      value={{
        open,
        close,
      }}
    >
      {children}
      {showMenu && (
        <MobileMenu
          close={close}
          onLoginClick={() => setShowLoginOverlay(true)}
        />
      )}
      {showLoginOverlay && (
        <LoginOverlay onClose={() => setShowLoginOverlay(false)} />
      )}
    </context.Provider>
  )
}

MobileMenuProvider.propTypes = {
  children: PropTypes.node,
}

export default function useMobileMenu() {
  const { open, close, opened } = useContext(context)
  return { open, close, opened }
}
